<template>
  <v-dialog 
    v-model="dialog"
    scrollable 
    persistent 
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <a v-on="on" class="black--text">
          {{ $t("message.consent_term_for_data_storage_and_use") }}
      </a>
    </template>

    <v-card class="rounded-edge">
      <v-card-title>
        <span class="headline">{{ $t("message.consent_term") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout wrap>
            <p>
            TERMO DE CONSENTIMENTO PARA ARMAZENAMENTO E USO DE DADOS
            </p>
            <p class="text-justify">
            Nossos produtos e serviços estão em conformidade com a
            legislação em vigor, incluindo a Lei Geral de Proteção de Dados, n.º
            13.709/2018 – LGPD e gostaríamos que você esteja ciente quanto ao
            armazenamento e uso de seus dados pessoais.
            </p>
            <p class="text-justify">
            Ao optar por utilizar o APP Inobram ou a Plataforma Inobram
            você precisa fornecer seus dados pessoais para realização de cadastro, a fim
            de que possamos ter conhecimento de quem são os usuários de nossos
            produtos. Com estes dados será possível que você crie login e senha para
            utilização dos produtos. Os dados necessários ao cadastro podem conter sua
            identificação, nome completo, número de documentos de identificação,
            endereço físico e eletrônico, e nós não manteremos arquivados informações
            relativas a sua senha de uso pessoal para acesso ao sistema.
            </p>
            <p class="text-justify">
            O software / APP da INOBRAM armazenará os dados pessoais
            que você disponibilizar em seu cadastro, inclusive quando houverem
            atualizações. Nós não compartilharemos seus dados pessoais sem o seu
            consentimento.
            </p>
            <p class="text-justify">
            Os dados arquivados no APP ou Plataforma Inobram que se
            referem à granja pertencem ao produtor e não são considerados dados
            pessoais para os fins da Lei Geral de Proteção de Dados. Mesmo assim, a
            INOBRAM comunica que não compartilhará as informações de sua granja sem
            o seu consentimento.
            </p>
            <p class="text-justify">
            A INOBRAM não disponibilizará os dados pessoais
            armazenados em seu software ou em seu servidor a terceiros, a menos que
            expressamente autorizada a sua divulgação pelo titular ou que se faça
            necessária por ordem de autoridade competente e nas demais hipótese
            previstas em lei.
            </p>
            <p class="text-justify">
            Se o seu banco de dados estiver armazenado em seu servidor,
            cabe a você adotar as medidas necessárias para limitar o acesso aos dados
            armazenados, inclusive autorização de acesso de prepostos e técnicos, não se
            estendendo qualquer responsabilidade para a INOBRAM.
            </p>
            <p class="text-justify">
            Sua senha é pessoal e a responsabilidade pela guarda da mesma é sua. Não mantemos cópias de senhas.
            </p>
            <p class="text-justify">
            Aceitando este termo, você outorga seu consentimento para
            que a INOBRAM arquive seus dados pessoais que forem fornecidos por você
            em seu cadastro, para fins de utilização do APP e/ou a Plataforma INOBRAM.              
            </p>
            <p>
            TERMO DE AUTORIZAÇÃO PARA COMPARTILHAMENTO DE INFORMAÇÕES DA GRANJA
            </p>
            <p class="text-justify">
            Pelo presente TERMO o produtor identificado no APP / Plataforma INOBRAM 
            por seu login e senha de uso pessoal AUTORIZA expressamente que a INOBRAM 
            compartilhe com a cooperativa as informações relativas aos 
            seus dados pessoais cadastrados no aplicativo (nome completo, telefone, CPF, 
            RG, endereço físico e eletrônico), bem como os dados relacionados a(s) 
            sua(s) granja(s), conforme armazenados no APP ou Plataforma, 
            para fins de controle das operações pela cooperativa.
            </p>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="pr-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          @click.native="dialog = false"
          depressed
          color="green lighten-5"
          class="green--text text--darken-4 mr-1 rounded-edge"
        >{{ $t('message.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped>
  .text-justify {
    text-align: justify; 
    text-justify: inter-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConsentTerm/ConsentTermDialog.vue